// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file wavin/sentio/v1/device_config.proto (package wavin.sentio.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wavin/sentio/v1/device_config.proto.
 */
export const file_wavin_sentio_v1_device_config: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * Sentio specific config
 *
 * @generated from message wavin.sentio.v1.DeviceConfig
 */
export type DeviceConfig = Message<"wavin.sentio.v1.DeviceConfig"> & {
  /**
   * @generated from field: optional string title = 12;
   */
  title?: string;

  /**
   * A custom title set on the device config per user
   *
   * @generated from field: optional string title_personalized = 13;
   */
  titlePersonalized?: string;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Room rooms = 1;
   */
  rooms: DeviceConfig_Room[];

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.VentilationControl ventilation_controls = 2;
   */
  ventilationControls: DeviceConfig_VentilationControl[];

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.VoltageFreeRelay voltage_free_relays = 3;
   */
  voltageFreeRelays: DeviceConfig_VoltageFreeRelay[];

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.OutdoorTemperatureSensor outdoor_temperature_sensors = 4;
   */
  outdoorTemperatureSensors: DeviceConfig_OutdoorTemperatureSensor[];

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.DomesticHotWaterUnit domestic_hot_water_units = 5;
   */
  domesticHotWaterUnits: DeviceConfig_DomesticHotWaterUnit[];

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.HCMode hc_mode = 6;
   */
  hcMode: DeviceConfig_HCMode;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.AutomaticHCMode automatic_hc_mode = 7;
   */
  automaticHcMode: DeviceConfig_AutomaticHCMode;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.HCMode available_hc_modes = 11;
   */
  availableHcModes: DeviceConfig_HCMode[];

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.StandbyMode standby_mode = 8;
   */
  standbyMode: DeviceConfig_StandbyMode;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VacationSettings vacation_settings = 9;
   */
  vacationSettings?: DeviceConfig_VacationSettings;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Notification notifications = 10;
   */
  notifications: DeviceConfig_Notification[];

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.QuietSettings quiet_settings = 14;
   */
  quietSettings?: DeviceConfig_QuietSettings;
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.
 * Use `create(DeviceConfigSchema)` to create a new message.
 */
export const DeviceConfigSchema: GenMessage<DeviceConfig> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.Room
 */
export type DeviceConfig_Room = Message<"wavin.sentio.v1.DeviceConfig.Room"> & {
  /**
   * read
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * read/write
   *
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string title_personalized = 17;
   */
  titlePersonalized?: string;

  /**
   * @generated from field: optional double air_temperature = 3;
   */
  airTemperature?: number;

  /**
   * @generated from field: optional double floor_temperature = 4;
   */
  floorTemperature?: number;

  /**
   * @generated from field: optional double humidity = 6;
   */
  humidity?: number;

  /**
   * @generated from field: optional double setpoint_temperature = 5;
   */
  setpointTemperature?: number;

  /**
   * @generated from field: optional double min_setpoint_temperature = 7;
   */
  minSetpointTemperature?: number;

  /**
   * @generated from field: optional double max_setpoint_temperature = 9;
   */
  maxSetpointTemperature?: number;

  /**
   * @generated from field: optional wavin.sentio.v1.DeviceConfig.VacationSettings.VacationMode vacation_mode = 10;
   */
  vacationMode?: DeviceConfig_VacationSettings_VacationMode;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.Type type = 20;
   */
  type: DeviceConfig_Room_Type;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.LockMode lock_mode = 11;
   */
  lockMode: DeviceConfig_Room_LockMode;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.TemperatureState temperature_state = 12;
   */
  temperatureState: DeviceConfig_Room_TemperatureState;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Room.TemperaturePreset temperature_presets = 13;
   */
  temperaturePresets: DeviceConfig_Room_TemperaturePreset[];

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Room.SystemMode system_modes = 15;
   */
  systemModes: DeviceConfig_Room_SystemMode[];

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Room.DehumidificationPreset dehumidification_presets = 18;
   */
  dehumidificationPresets: DeviceConfig_Room_DehumidificationPreset[];

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.DehumidifierState dehumidifier_state = 19;
   */
  dehumidifierState: DeviceConfig_Room_DehumidifierState;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule weekly_schedule = 14;
   */
  weeklySchedule?: DeviceConfig_Room_WeeklySchedule;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Notification notifications = 16;
   */
  notifications: DeviceConfig_Notification[];
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.Room.
 * Use `create(DeviceConfig_RoomSchema)` to create a new message.
 */
export const DeviceConfig_RoomSchema: GenMessage<DeviceConfig_Room> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 0);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.Room.TemperaturePreset
 */
export type DeviceConfig_Room_TemperaturePreset = Message<"wavin.sentio.v1.DeviceConfig.Room.TemperaturePreset"> & {
  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.TemperaturePreset.Type type = 1;
   */
  type: DeviceConfig_Room_TemperaturePreset_Type;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.HCMode hc_mode = 2;
   */
  hcMode: DeviceConfig_HCMode;

  /**
   * @generated from field: double setpoint_temperature = 3;
   */
  setpointTemperature: number;

  /**
   * @generated from field: optional double min_setpoint_temperature = 4;
   */
  minSetpointTemperature?: number;

  /**
   * @generated from field: optional double max_setpoint_temperature = 5;
   */
  maxSetpointTemperature?: number;
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.Room.TemperaturePreset.
 * Use `create(DeviceConfig_Room_TemperaturePresetSchema)` to create a new message.
 */
export const DeviceConfig_Room_TemperaturePresetSchema: GenMessage<DeviceConfig_Room_TemperaturePreset> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 0, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.Room.TemperaturePreset.Type
 */
export enum DeviceConfig_Room_TemperaturePreset_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TYPE_ECO = 1;
   */
  ECO = 1,

  /**
   * @generated from enum value: TYPE_COMFORT = 2;
   */
  COMFORT = 2,

  /**
   * @generated from enum value: TYPE_EXTRA_COMFORT = 3;
   */
  EXTRA_COMFORT = 3,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Room.TemperaturePreset.Type.
 */
export const DeviceConfig_Room_TemperaturePreset_TypeSchema: GenEnum<DeviceConfig_Room_TemperaturePreset_Type> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 0, 0, 0);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.Room.SystemMode
 */
export type DeviceConfig_Room_SystemMode = Message<"wavin.sentio.v1.DeviceConfig.Room.SystemMode"> & {
  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.SystemMode.Type type = 1;
   */
  type: DeviceConfig_Room_SystemMode_Type;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.HCMode hc_mode = 2;
   */
  hcMode: DeviceConfig_HCMode;

  /**
   * @generated from field: double setpoint_temperature = 3;
   */
  setpointTemperature: number;

  /**
   * @generated from field: optional double min_setpoint_temperature = 4;
   */
  minSetpointTemperature?: number;

  /**
   * @generated from field: optional double max_setpoint_temperature = 5;
   */
  maxSetpointTemperature?: number;
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.Room.SystemMode.
 * Use `create(DeviceConfig_Room_SystemModeSchema)` to create a new message.
 */
export const DeviceConfig_Room_SystemModeSchema: GenMessage<DeviceConfig_Room_SystemMode> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 0, 1);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.Room.SystemMode.Type
 */
export enum DeviceConfig_Room_SystemMode_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TYPE_STANDBY = 1;
   */
  STANDBY = 1,

  /**
   * @generated from enum value: TYPE_VACATION = 2;
   */
  VACATION = 2,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Room.SystemMode.Type.
 */
export const DeviceConfig_Room_SystemMode_TypeSchema: GenEnum<DeviceConfig_Room_SystemMode_Type> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 0, 1, 0);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.Room.DehumidificationPreset
 */
export type DeviceConfig_Room_DehumidificationPreset = Message<"wavin.sentio.v1.DeviceConfig.Room.DehumidificationPreset"> & {
  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.HCMode hc_mode = 1;
   */
  hcMode: DeviceConfig_HCMode;

  /**
   * @generated from field: double setpoint = 2;
   */
  setpoint: number;

  /**
   * @generated from field: optional double min_humidity_setpoint = 3;
   */
  minHumiditySetpoint?: number;

  /**
   * @generated from field: optional double max_humidity_setpoint = 4;
   */
  maxHumiditySetpoint?: number;
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.Room.DehumidificationPreset.
 * Use `create(DeviceConfig_Room_DehumidificationPresetSchema)` to create a new message.
 */
export const DeviceConfig_Room_DehumidificationPresetSchema: GenMessage<DeviceConfig_Room_DehumidificationPreset> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 0, 2);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule
 */
export type DeviceConfig_Room_WeeklySchedule = Message<"wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule"> & {
  /**
   * currently defaults to Eco, could change in future
   *
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.TemperaturePreset.Type default_preset_type = 1;
   */
  defaultPresetType: DeviceConfig_Room_TemperaturePreset_Type;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Mode schedule_mode = 3;
   */
  scheduleMode: DeviceConfig_Room_WeeklySchedule_Mode;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Interval intervals = 4;
   */
  intervals: DeviceConfig_Room_WeeklySchedule_Interval[];
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.
 * Use `create(DeviceConfig_Room_WeeklyScheduleSchema)` to create a new message.
 */
export const DeviceConfig_Room_WeeklyScheduleSchema: GenMessage<DeviceConfig_Room_WeeklySchedule> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 0, 3);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Interval
 */
export type DeviceConfig_Room_WeeklySchedule_Interval = Message<"wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Interval"> & {
  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Interval.DayOfWeek day = 1;
   */
  day: DeviceConfig_Room_WeeklySchedule_Interval_DayOfWeek;

  /**
   * A fixed array of 96 preset types. Each entry is a timeframe of 15 minutes, starting from 00:00
   *
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Room.TemperaturePreset.Type preset_timeframes = 2;
   */
  presetTimeframes: DeviceConfig_Room_TemperaturePreset_Type[];
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Interval.
 * Use `create(DeviceConfig_Room_WeeklySchedule_IntervalSchema)` to create a new message.
 */
export const DeviceConfig_Room_WeeklySchedule_IntervalSchema: GenMessage<DeviceConfig_Room_WeeklySchedule_Interval> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 0, 3, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Interval.DayOfWeek
 */
export enum DeviceConfig_Room_WeeklySchedule_Interval_DayOfWeek {
  /**
   * @generated from enum value: DAY_OF_WEEK_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DAY_OF_WEEK_MONDAY = 1;
   */
  MONDAY = 1,

  /**
   * @generated from enum value: DAY_OF_WEEK_TUESDAY = 2;
   */
  TUESDAY = 2,

  /**
   * @generated from enum value: DAY_OF_WEEK_WEDNESDAY = 3;
   */
  WEDNESDAY = 3,

  /**
   * @generated from enum value: DAY_OF_WEEK_THURSDAY = 4;
   */
  THURSDAY = 4,

  /**
   * @generated from enum value: DAY_OF_WEEK_FRIDAY = 5;
   */
  FRIDAY = 5,

  /**
   * @generated from enum value: DAY_OF_WEEK_SATURDAY = 6;
   */
  SATURDAY = 6,

  /**
   * @generated from enum value: DAY_OF_WEEK_SUNDAY = 7;
   */
  SUNDAY = 7,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Interval.DayOfWeek.
 */
export const DeviceConfig_Room_WeeklySchedule_Interval_DayOfWeekSchema: GenEnum<DeviceConfig_Room_WeeklySchedule_Interval_DayOfWeek> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 0, 3, 0, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Mode
 */
export enum DeviceConfig_Room_WeeklySchedule_Mode {
  /**
   * @generated from enum value: MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MODE_OFF = 1;
   */
  OFF = 1,

  /**
   * @generated from enum value: MODE_ON = 2;
   */
  ON = 2,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Room.WeeklySchedule.Mode.
 */
export const DeviceConfig_Room_WeeklySchedule_ModeSchema: GenEnum<DeviceConfig_Room_WeeklySchedule_Mode> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 0, 3, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.Room.Type
 */
export enum DeviceConfig_Room_Type {
  /**
   * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
   *
   * @generated from enum value: TYPE_DEFAULT = 0;
   */
  DEFAULT = 0,

  /**
   * @generated from enum value: TYPE_DUMMY = 1;
   */
  DUMMY = 1,

  /**
   * @generated from enum value: TYPE_REFERENCE = 2;
   */
  REFERENCE = 2,

  /**
   * @generated from enum value: TYPE_RADIATOR_CONTROLLED = 3;
   */
  RADIATOR_CONTROLLED = 3,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Room.Type.
 */
export const DeviceConfig_Room_TypeSchema: GenEnum<DeviceConfig_Room_Type> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 0, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.Room.LockMode
 */
export enum DeviceConfig_Room_LockMode {
  /**
   * @generated from enum value: LOCK_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOCK_MODE_UNLOCKED = 1;
   */
  UNLOCKED = 1,

  /**
   * @generated from enum value: LOCK_MODE_LOCKED = 2;
   */
  LOCKED = 2,

  /**
   * @generated from enum value: LOCK_MODE_HOTEL = 3;
   */
  HOTEL = 3,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Room.LockMode.
 */
export const DeviceConfig_Room_LockModeSchema: GenEnum<DeviceConfig_Room_LockMode> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 0, 1);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.Room.TemperatureState
 */
export enum DeviceConfig_Room_TemperatureState {
  /**
   * @generated from enum value: TEMPERATURE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEMPERATURE_STATE_IDLE = 1;
   */
  IDLE = 1,

  /**
   * @generated from enum value: TEMPERATURE_STATE_HEATING = 2;
   */
  HEATING = 2,

  /**
   * @generated from enum value: TEMPERATURE_STATE_COOLING = 3;
   */
  COOLING = 3,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Room.TemperatureState.
 */
export const DeviceConfig_Room_TemperatureStateSchema: GenEnum<DeviceConfig_Room_TemperatureState> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 0, 2);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.Room.DehumidifierState
 */
export enum DeviceConfig_Room_DehumidifierState {
  /**
   * @generated from enum value: DEHUMIDIFIER_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEHUMIDIFIER_STATE_OFF = 1;
   */
  OFF = 1,

  /**
   * IDLE is OFF and waiting for demand
   *
   * @generated from enum value: DEHUMIDIFIER_STATE_IDLE = 2;
   */
  IDLE = 2,

  /**
   * @generated from enum value: DEHUMIDIFIER_STATE_ACTIVE = 3;
   */
  ACTIVE = 3,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Room.DehumidifierState.
 */
export const DeviceConfig_Room_DehumidifierStateSchema: GenEnum<DeviceConfig_Room_DehumidifierState> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 0, 3);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.VentilationControl
 */
export type DeviceConfig_VentilationControl = Message<"wavin.sentio.v1.DeviceConfig.VentilationControl"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string title_personalized = 8;
   */
  titlePersonalized?: string;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VentilationControl.Mode mode = 3;
   */
  mode: DeviceConfig_VentilationControl_Mode;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.VentilationControl.Mode allowed_modes = 4;
   */
  allowedModes: DeviceConfig_VentilationControl_Mode[];

  /**
   * @generated from field: optional google.protobuf.Timestamp boost_until = 5;
   */
  boostUntil?: Timestamp;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Notification notifications = 6;
   */
  notifications: DeviceConfig_Notification[];

  /**
   * @generated from field: optional wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter ventilation_filter = 7;
   */
  ventilationFilter?: DeviceConfig_VentilationControl_VentilationFilter;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VentilationControl.Control control = 9;
   */
  control: DeviceConfig_VentilationControl_Control;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule ventilation_weekly_schedule = 21;
   */
  ventilationWeeklySchedule?: DeviceConfig_VentilationControl_VentilationWeeklySchedule;
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.VentilationControl.
 * Use `create(DeviceConfig_VentilationControlSchema)` to create a new message.
 */
export const DeviceConfig_VentilationControlSchema: GenMessage<DeviceConfig_VentilationControl> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 1);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter
 */
export type DeviceConfig_VentilationControl_VentilationFilter = Message<"wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp last_changed = 1;
   */
  lastChanged?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp lifetime = 2;
   */
  lifetime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp lifetime_used = 3;
   */
  lifetimeUsed?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp maintenance_end_time = 4;
   */
  maintenanceEndTime?: Timestamp;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter.MaintenanceState maintenance_state = 5;
   */
  maintenanceState: DeviceConfig_VentilationControl_VentilationFilter_MaintenanceState;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter.Command command = 6;
   */
  command: DeviceConfig_VentilationControl_VentilationFilter_Command;
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter.
 * Use `create(DeviceConfig_VentilationControl_VentilationFilterSchema)` to create a new message.
 */
export const DeviceConfig_VentilationControl_VentilationFilterSchema: GenMessage<DeviceConfig_VentilationControl_VentilationFilter> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 1, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter.MaintenanceState
 */
export enum DeviceConfig_VentilationControl_VentilationFilter_MaintenanceState {
  /**
   * @generated from enum value: MAINTENANCE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MAINTENANCE_STATE_INACTIVE = 1;
   */
  INACTIVE = 1,

  /**
   * @generated from enum value: MAINTENANCE_STATE_REQUIRED = 2;
   */
  REQUIRED = 2,

  /**
   * @generated from enum value: MAINTENANCE_STATE_AWAITING_TIMED = 3;
   */
  AWAITING_TIMED = 3,

  /**
   * @generated from enum value: MAINTENANCE_STATE_SHUTTING_DOWN = 4;
   */
  SHUTTING_DOWN = 4,

  /**
   * @generated from enum value: MAINTENANCE_STATE_STARTING_UP = 5;
   */
  STARTING_UP = 5,

  /**
   * @generated from enum value: MAINTENANCE_STATE_ERROR = 6;
   */
  ERROR = 6,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter.MaintenanceState.
 */
export const DeviceConfig_VentilationControl_VentilationFilter_MaintenanceStateSchema: GenEnum<DeviceConfig_VentilationControl_VentilationFilter_MaintenanceState> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 1, 0, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter.Command
 */
export enum DeviceConfig_VentilationControl_VentilationFilter_Command {
  /**
   * @generated from enum value: COMMAND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMMAND_STOP_OPERATION = 1;
   */
  STOP_OPERATION = 1,

  /**
   * @generated from enum value: COMMAND_RESUME_OPERATION = 2;
   */
  RESUME_OPERATION = 2,

  /**
   * @generated from enum value: COMMAND_RESET_AIR_FILTER = 3;
   */
  RESET_AIR_FILTER = 3,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationFilter.Command.
 */
export const DeviceConfig_VentilationControl_VentilationFilter_CommandSchema: GenEnum<DeviceConfig_VentilationControl_VentilationFilter_Command> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 1, 0, 1);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule
 */
export type DeviceConfig_VentilationControl_VentilationWeeklySchedule = Message<"wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule"> & {
  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VentilationControl.Mode default_mode = 1;
   */
  defaultMode: DeviceConfig_VentilationControl_Mode;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Mode schedule_mode = 3;
   */
  scheduleMode: DeviceConfig_VentilationControl_VentilationWeeklySchedule_Mode;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Interval intervals = 4;
   */
  intervals: DeviceConfig_VentilationControl_VentilationWeeklySchedule_Interval[];
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.
 * Use `create(DeviceConfig_VentilationControl_VentilationWeeklyScheduleSchema)` to create a new message.
 */
export const DeviceConfig_VentilationControl_VentilationWeeklyScheduleSchema: GenMessage<DeviceConfig_VentilationControl_VentilationWeeklySchedule> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 1, 1);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Interval
 */
export type DeviceConfig_VentilationControl_VentilationWeeklySchedule_Interval = Message<"wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Interval"> & {
  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Interval.DayOfWeek day = 1;
   */
  day: DeviceConfig_VentilationControl_VentilationWeeklySchedule_Interval_DayOfWeek;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.VentilationControl.Mode mode_timeframes = 2;
   */
  modeTimeframes: DeviceConfig_VentilationControl_Mode[];
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Interval.
 * Use `create(DeviceConfig_VentilationControl_VentilationWeeklySchedule_IntervalSchema)` to create a new message.
 */
export const DeviceConfig_VentilationControl_VentilationWeeklySchedule_IntervalSchema: GenMessage<DeviceConfig_VentilationControl_VentilationWeeklySchedule_Interval> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 1, 1, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Interval.DayOfWeek
 */
export enum DeviceConfig_VentilationControl_VentilationWeeklySchedule_Interval_DayOfWeek {
  /**
   * @generated from enum value: DAY_OF_WEEK_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DAY_OF_WEEK_MONDAY = 1;
   */
  MONDAY = 1,

  /**
   * @generated from enum value: DAY_OF_WEEK_TUESDAY = 2;
   */
  TUESDAY = 2,

  /**
   * @generated from enum value: DAY_OF_WEEK_WEDNESDAY = 3;
   */
  WEDNESDAY = 3,

  /**
   * @generated from enum value: DAY_OF_WEEK_THURSDAY = 4;
   */
  THURSDAY = 4,

  /**
   * @generated from enum value: DAY_OF_WEEK_FRIDAY = 5;
   */
  FRIDAY = 5,

  /**
   * @generated from enum value: DAY_OF_WEEK_SATURDAY = 6;
   */
  SATURDAY = 6,

  /**
   * @generated from enum value: DAY_OF_WEEK_SUNDAY = 7;
   */
  SUNDAY = 7,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Interval.DayOfWeek.
 */
export const DeviceConfig_VentilationControl_VentilationWeeklySchedule_Interval_DayOfWeekSchema: GenEnum<DeviceConfig_VentilationControl_VentilationWeeklySchedule_Interval_DayOfWeek> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 1, 1, 0, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Mode
 */
export enum DeviceConfig_VentilationControl_VentilationWeeklySchedule_Mode {
  /**
   * @generated from enum value: MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MODE_OFF = 1;
   */
  OFF = 1,

  /**
   * @generated from enum value: MODE_ON = 2;
   */
  ON = 2,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.VentilationControl.VentilationWeeklySchedule.Mode.
 */
export const DeviceConfig_VentilationControl_VentilationWeeklySchedule_ModeSchema: GenEnum<DeviceConfig_VentilationControl_VentilationWeeklySchedule_Mode> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 1, 1, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.VentilationControl.Mode
 */
export enum DeviceConfig_VentilationControl_Mode {
  /**
   * @generated from enum value: MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MODE_STOPPED = 1;
   */
  STOPPED = 1,

  /**
   * @generated from enum value: MODE_UNOCCUPIED = 2;
   */
  UNOCCUPIED = 2,

  /**
   * @generated from enum value: MODE_ECO = 3;
   */
  ECO = 3,

  /**
   * @generated from enum value: MODE_COMFORT = 4;
   */
  COMFORT = 4,

  /**
   * @generated from enum value: MODE_BOOST = 5;
   */
  BOOST = 5,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.VentilationControl.Mode.
 */
export const DeviceConfig_VentilationControl_ModeSchema: GenEnum<DeviceConfig_VentilationControl_Mode> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 1, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.VentilationControl.Control
 */
export enum DeviceConfig_VentilationControl_Control {
  /**
   * @generated from enum value: CONTROL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTROL_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: CONTROL_HUMIDITY = 2;
   */
  HUMIDITY = 2,

  /**
   * @generated from enum value: CONTROL_FREE_COOLING = 3;
   */
  FREE_COOLING = 3,

  /**
   * @generated from enum value: CONTROL_EXTERNAL = 4;
   */
  EXTERNAL = 4,

  /**
   * @generated from enum value: CONTROL_CO2 = 5;
   */
  CO2 = 5,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.VentilationControl.Control.
 */
export const DeviceConfig_VentilationControl_ControlSchema: GenEnum<DeviceConfig_VentilationControl_Control> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 1, 1);

/**
 * VFR as abbreviation
 *
 * @generated from message wavin.sentio.v1.DeviceConfig.VoltageFreeRelay
 */
export type DeviceConfig_VoltageFreeRelay = Message<"wavin.sentio.v1.DeviceConfig.VoltageFreeRelay"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional bool enabled = 2;
   */
  enabled?: boolean;

  /**
   * @generated from field: optional string title = 3;
   */
  title?: string;

  /**
   * @generated from field: optional string title_personalized = 5;
   */
  titlePersonalized?: string;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Notification notifications = 4;
   */
  notifications: DeviceConfig_Notification[];
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.VoltageFreeRelay.
 * Use `create(DeviceConfig_VoltageFreeRelaySchema)` to create a new message.
 */
export const DeviceConfig_VoltageFreeRelaySchema: GenMessage<DeviceConfig_VoltageFreeRelay> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 2);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.OutdoorTemperatureSensor
 */
export type DeviceConfig_OutdoorTemperatureSensor = Message<"wavin.sentio.v1.DeviceConfig.OutdoorTemperatureSensor"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional double outdoor_temperature = 2;
   */
  outdoorTemperature?: number;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Notification notifications = 3;
   */
  notifications: DeviceConfig_Notification[];
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.OutdoorTemperatureSensor.
 * Use `create(DeviceConfig_OutdoorTemperatureSensorSchema)` to create a new message.
 */
export const DeviceConfig_OutdoorTemperatureSensorSchema: GenMessage<DeviceConfig_OutdoorTemperatureSensor> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 3);

/**
 * DHW as abbreviation
 *
 * @generated from message wavin.sentio.v1.DeviceConfig.DomesticHotWaterUnit
 */
export type DeviceConfig_DomesticHotWaterUnit = Message<"wavin.sentio.v1.DeviceConfig.DomesticHotWaterUnit"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional double setpoint_temperature = 2;
   */
  setpointTemperature?: number;

  /**
   * @generated from field: optional string title = 3;
   */
  title?: string;

  /**
   * @generated from field: optional string title_personalized = 7;
   */
  titlePersonalized?: string;

  /**
   * @generated from field: optional double min_temperature = 4;
   */
  minTemperature?: number;

  /**
   * @generated from field: optional double max_temperature = 5;
   */
  maxTemperature?: number;

  /**
   * @generated from field: repeated wavin.sentio.v1.DeviceConfig.Notification notifications = 6;
   */
  notifications: DeviceConfig_Notification[];
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.DomesticHotWaterUnit.
 * Use `create(DeviceConfig_DomesticHotWaterUnitSchema)` to create a new message.
 */
export const DeviceConfig_DomesticHotWaterUnitSchema: GenMessage<DeviceConfig_DomesticHotWaterUnit> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 4);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.VacationSettings
 */
export type DeviceConfig_VacationSettings = Message<"wavin.sentio.v1.DeviceConfig.VacationSettings"> & {
  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.VacationSettings.VacationMode vacation_mode = 1;
   */
  vacationMode: DeviceConfig_VacationSettings_VacationMode;

  /**
   * @generated from field: optional google.protobuf.Timestamp vacation_mode_until = 3;
   */
  vacationModeUntil?: Timestamp;
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.VacationSettings.
 * Use `create(DeviceConfig_VacationSettingsSchema)` to create a new message.
 */
export const DeviceConfig_VacationSettingsSchema: GenMessage<DeviceConfig_VacationSettings> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 5);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.VacationSettings.VacationMode
 */
export enum DeviceConfig_VacationSettings_VacationMode {
  /**
   * @generated from enum value: VACATION_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VACATION_MODE_OFF = 1;
   */
  OFF = 1,

  /**
   * @generated from enum value: VACATION_MODE_ON = 2;
   */
  ON = 2,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.VacationSettings.VacationMode.
 */
export const DeviceConfig_VacationSettings_VacationModeSchema: GenEnum<DeviceConfig_VacationSettings_VacationMode> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 5, 0);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.Notification
 */
export type DeviceConfig_Notification = Message<"wavin.sentio.v1.DeviceConfig.Notification"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Notification.Severity severity = 3;
   */
  severity: DeviceConfig_Notification_Severity;

  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.Notification.Key key = 4;
   */
  key: DeviceConfig_Notification_Key;

  /**
   * Arguments for key
   *
   * @generated from field: repeated string args = 5;
   */
  args: string[];
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.Notification.
 * Use `create(DeviceConfig_NotificationSchema)` to create a new message.
 */
export const DeviceConfig_NotificationSchema: GenMessage<DeviceConfig_Notification> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 6);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.Notification.Severity
 */
export enum DeviceConfig_Notification_Severity {
  /**
   * @generated from enum value: SEVERITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEVERITY_INFO = 1;
   */
  INFO = 1,

  /**
   * @generated from enum value: SEVERITY_WARNING = 2;
   */
  WARNING = 2,

  /**
   * @generated from enum value: SEVERITY_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Notification.Severity.
 */
export const DeviceConfig_Notification_SeveritySchema: GenEnum<DeviceConfig_Notification_Severity> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 6, 0);

/**
 * prefixed with topology objects: room, ventilation, vfr etc.
 *
 * @generated from enum wavin.sentio.v1.DeviceConfig.Notification.Key
 */
export enum DeviceConfig_Notification_Key {
  /**
   * @generated from enum value: KEY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: KEY_ROOM_PERIPHERAL_LOST = 100;
   */
  ROOM_PERIPHERAL_LOST = 100,

  /**
   * @generated from enum value: KEY_ROOM_TEMPERATURE_CRITICALLY_LOW = 101;
   */
  ROOM_TEMPERATURE_CRITICALLY_LOW = 101,

  /**
   * @generated from enum value: KEY_ROOM_TEMPERATURE_CRITICALLY_HIGH = 102;
   */
  ROOM_TEMPERATURE_CRITICALLY_HIGH = 102,

  /**
   * @generated from enum value: KEY_ROOM_FLOOR_TEMPERATURE_CRITICALLY_LOW = 103;
   */
  ROOM_FLOOR_TEMPERATURE_CRITICALLY_LOW = 103,

  /**
   * @generated from enum value: KEY_ROOM_FLOOR_TEMPERATURE_CRITICALLY_HIGH = 104;
   */
  ROOM_FLOOR_TEMPERATURE_CRITICALLY_HIGH = 104,

  /**
   * @generated from enum value: KEY_ROOM_FROST_PROTECTION_ACTIVE = 105;
   */
  ROOM_FROST_PROTECTION_ACTIVE = 105,

  /**
   * @generated from enum value: KEY_ROOM_BATTERY_COVER_OPEN = 106;
   */
  ROOM_BATTERY_COVER_OPEN = 106,

  /**
   * @generated from enum value: KEY_ROOM_INCORRECT_PERIPHERAL_INSTALLED = 107;
   */
  ROOM_INCORRECT_PERIPHERAL_INSTALLED = 107,

  /**
   * @generated from enum value: KEY_ROOM_VALVE_STICKING = 108;
   */
  ROOM_VALVE_STICKING = 108,

  /**
   * @generated from enum value: KEY_ROOM_GENERAL_PROBLEM = 109;
   */
  ROOM_GENERAL_PROBLEM = 109,

  /**
   * @generated from enum value: KEY_ROOM_DRYER_GENERAL_FAULT = 110;
   */
  ROOM_DRYER_GENERAL_FAULT = 110,

  /**
   * @generated from enum value: KEY_ROOM_DRYER_MAINTENANCE = 111;
   */
  ROOM_DRYER_MAINTENANCE = 111,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_UNSPECIFIED = 150;
   */
  ROOM_BLOCKING_HEATING_UNSPECIFIED = 150,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_UNKNOWN = 151;
   */
  ROOM_BLOCKING_HEATING_UNKNOWN = 151,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_FLOOR_TEMP = 152;
   */
  ROOM_BLOCKING_HEATING_FLOOR_TEMP = 152,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_AIR_TEMP = 153;
   */
  ROOM_BLOCKING_HEATING_AIR_TEMP = 153,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_DEW_POINT = 154;
   */
  ROOM_BLOCKING_HEATING_DEW_POINT = 154,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_OUTDOOR_TEMP = 155;
   */
  ROOM_BLOCKING_HEATING_OUTDOOR_TEMP = 155,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_FAULT = 156;
   */
  ROOM_BLOCKING_HEATING_FAULT = 156,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_FAULT_HTCO = 157;
   */
  ROOM_BLOCKING_HEATING_FAULT_HTCO = 157,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_PERIODIC_ACTIVATION = 158;
   */
  ROOM_BLOCKING_HEATING_PERIODIC_ACTIVATION = 158,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_HCW_SOURCE_NOT_RELEASED = 159;
   */
  ROOM_BLOCKING_HEATING_HCW_SOURCE_NOT_RELEASED = 159,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_ROOM_MODE = 160;
   */
  ROOM_BLOCKING_HEATING_ROOM_MODE = 160,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_NO_OUTPUT = 161;
   */
  ROOM_BLOCKING_HEATING_NO_OUTPUT = 161,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_FIRST_OPEN_ACTIVATION = 162;
   */
  ROOM_BLOCKING_HEATING_FIRST_OPEN_ACTIVATION = 162,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_ROOM_WITH_NO_TEMP_SOURCE = 163;
   */
  ROOM_BLOCKING_HEATING_ROOM_WITH_NO_TEMP_SOURCE = 163,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_HCWS_ELEMENTS_BLOCKED = 164;
   */
  ROOM_BLOCKING_HEATING_HCWS_ELEMENTS_BLOCKED = 164,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_SUPPLIER_UNAVAILABLE = 165;
   */
  ROOM_BLOCKING_HEATING_SUPPLIER_UNAVAILABLE = 165,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_HEATING_NO_SUPPLIER = 166;
   */
  ROOM_BLOCKING_HEATING_NO_SUPPLIER = 166,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_UNSPECIFIED = 170;
   */
  ROOM_BLOCKING_COOLING_UNSPECIFIED = 170,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_UNKNOWN = 171;
   */
  ROOM_BLOCKING_COOLING_UNKNOWN = 171,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_FLOOR_TEMP = 172;
   */
  ROOM_BLOCKING_COOLING_FLOOR_TEMP = 172,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_AIR_TEMP = 173;
   */
  ROOM_BLOCKING_COOLING_AIR_TEMP = 173,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_DEW_POINT = 174;
   */
  ROOM_BLOCKING_COOLING_DEW_POINT = 174,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_OUTDOOR_TEMP = 175;
   */
  ROOM_BLOCKING_COOLING_OUTDOOR_TEMP = 175,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_FAULT = 176;
   */
  ROOM_BLOCKING_COOLING_FAULT = 176,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_FAULT_HTCO = 177;
   */
  ROOM_BLOCKING_COOLING_FAULT_HTCO = 177,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_PERIODIC_ACTIVATION = 178;
   */
  ROOM_BLOCKING_COOLING_PERIODIC_ACTIVATION = 178,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_HCW_SOURCE_NOT_RELEASED = 179;
   */
  ROOM_BLOCKING_COOLING_HCW_SOURCE_NOT_RELEASED = 179,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_ROOM_MODE = 180;
   */
  ROOM_BLOCKING_COOLING_ROOM_MODE = 180,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_NO_OUTPUT = 181;
   */
  ROOM_BLOCKING_COOLING_NO_OUTPUT = 181,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_FIRST_OPEN_ACTIVATION = 182;
   */
  ROOM_BLOCKING_COOLING_FIRST_OPEN_ACTIVATION = 182,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_ROOM_WITH_NO_TEMP_SOURCE = 183;
   */
  ROOM_BLOCKING_COOLING_ROOM_WITH_NO_TEMP_SOURCE = 183,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_HCWS_ELEMENTS_BLOCKED = 184;
   */
  ROOM_BLOCKING_COOLING_HCWS_ELEMENTS_BLOCKED = 184,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_SUPPLIER_UNAVAILABLE = 185;
   */
  ROOM_BLOCKING_COOLING_SUPPLIER_UNAVAILABLE = 185,

  /**
   * @generated from enum value: KEY_ROOM_BLOCKING_COOLING_NO_SUPPLIER = 186;
   */
  ROOM_BLOCKING_COOLING_NO_SUPPLIER = 186,

  /**
   * Domestic Hot Water Unit
   *
   * @generated from enum value: KEY_DHW_CRITICALLY_LOW_PRESSURE = 200;
   */
  DHW_CRITICALLY_LOW_PRESSURE = 200,

  /**
   * @generated from enum value: KEY_DHW_LOW_PRESSURE = 201;
   */
  DHW_LOW_PRESSURE = 201,

  /**
   * @generated from enum value: KEY_DHW_HIGH_PRESSURE = 202;
   */
  DHW_HIGH_PRESSURE = 202,

  /**
   * @generated from enum value: KEY_DHW_LOW_ENERGY = 203;
   */
  DHW_LOW_ENERGY = 203,

  /**
   * @generated from enum value: KEY_DHW_HIGH_TEMPERATURE = 204;
   */
  DHW_HIGH_TEMPERATURE = 204,

  /**
   * @generated from enum value: KEY_DHW_DHI_SENSOR_FAILURE = 205;
   */
  DHW_DHI_SENSOR_FAILURE = 205,

  /**
   * @generated from enum value: KEY_DHW_DHO_SENSOR_FAILURE = 206;
   */
  DHW_DHO_SENSOR_FAILURE = 206,

  /**
   * @generated from enum value: KEY_DHW_DHW_SENSOR_FAILURE = 207;
   */
  DHW_DHW_SENSOR_FAILURE = 207,

  /**
   * @generated from enum value: KEY_DHW_DCW_SENSOR_FAILURE = 208;
   */
  DHW_DCW_SENSOR_FAILURE = 208,

  /**
   * @generated from enum value: KEY_DHW_MOTOR_FAILURE = 209;
   */
  DHW_MOTOR_FAILURE = 209,

  /**
   * @generated from enum value: KEY_DHW_PRESSURE_SENSOR_FAILURE = 210;
   */
  DHW_PRESSURE_SENSOR_FAILURE = 210,

  /**
   * @generated from enum value: KEY_DHW_FLOW_SENSOR_FAILURE = 211;
   */
  DHW_FLOW_SENSOR_FAILURE = 211,

  /**
   * @generated from enum value: KEY_DHW_CIRCULATION_SENSOR_FAILURE = 212;
   */
  DHW_CIRCULATION_SENSOR_FAILURE = 212,

  /**
   * @generated from enum value: KEY_DHW_HEATING_MOTOR_FAILURE = 213;
   */
  DHW_HEATING_MOTOR_FAILURE = 213,

  /**
   * @generated from enum value: KEY_DHW_HEATING_MOTOR_STUCK = 214;
   */
  DHW_HEATING_MOTOR_STUCK = 214,

  /**
   * @generated from enum value: KEY_VENTILATION_FILTERS_TO_BE_REPLACED = 300;
   */
  VENTILATION_FILTERS_TO_BE_REPLACED = 300,

  /**
   * @generated from enum value: KEY_VENTILATION_CONNECTION_LOST = 301;
   */
  VENTILATION_CONNECTION_LOST = 301,

  /**
   * @generated from enum value: KEY_VENTILATION_RESTART = 302;
   */
  VENTILATION_RESTART = 302,

  /**
   * @generated from enum value: KEY_VENTILATION_GENERAL_ISSUE = 303;
   */
  VENTILATION_GENERAL_ISSUE = 303,

  /**
   * @generated from enum value: KEY_SYSTEM_EXTERNAL_DEVICE_ISSUE = 400;
   */
  SYSTEM_EXTERNAL_DEVICE_ISSUE = 400,

  /**
   * @generated from enum value: KEY_SYSTEM_HEAT_PUMP_ISSUE = 401;
   */
  SYSTEM_HEAT_PUMP_ISSUE = 401,

  /**
   * @generated from enum value: KEY_SYSTEM_INCOMPATIBLE_PERIPHERAL = 402;
   */
  SYSTEM_INCOMPATIBLE_PERIPHERAL = 402,

  /**
   * @generated from enum value: KEY_SYSTEM_EXTERNAL_HEAT_PUMP_ISSUE = 403;
   */
  SYSTEM_EXTERNAL_HEAT_PUMP_ISSUE = 403,

  /**
   * @generated from enum value: KEY_SYSTEM_HC_MODE_UPDATED = 450;
   */
  SYSTEM_HC_MODE_UPDATED = 450,

  /**
   * @generated from enum value: KEY_SYSTEM_VACATION_MODE_UPDATED = 451;
   */
  SYSTEM_VACATION_MODE_UPDATED = 451,

  /**
   * @generated from enum value: KEY_SYSTEM_STANDBY_MODE_UPDATED = 452;
   */
  SYSTEM_STANDBY_MODE_UPDATED = 452,

  /**
   * Cloud exclusive
   *
   * @generated from enum value: KEY_DEVICE_FIRMWARE_UPDATE_AVAILABLE = 500;
   */
  DEVICE_FIRMWARE_UPDATE_AVAILABLE = 500,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.Notification.Key.
 */
export const DeviceConfig_Notification_KeySchema: GenEnum<DeviceConfig_Notification_Key> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 6, 1);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.QuietSettings
 */
export type DeviceConfig_QuietSettings = Message<"wavin.sentio.v1.DeviceConfig.QuietSettings"> & {
  /**
   * @generated from field: wavin.sentio.v1.DeviceConfig.QuietSettings.QuietMode mode = 1;
   */
  mode: DeviceConfig_QuietSettings_QuietMode;

  /**
   * @generated from field: optional wavin.sentio.v1.DeviceConfig.QuietSettings.TimeOfDay from = 2;
   */
  from?: DeviceConfig_QuietSettings_TimeOfDay;

  /**
   * @generated from field: optional wavin.sentio.v1.DeviceConfig.QuietSettings.TimeOfDay to = 3;
   */
  to?: DeviceConfig_QuietSettings_TimeOfDay;
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.QuietSettings.
 * Use `create(DeviceConfig_QuietSettingsSchema)` to create a new message.
 */
export const DeviceConfig_QuietSettingsSchema: GenMessage<DeviceConfig_QuietSettings> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 7);

/**
 * @generated from message wavin.sentio.v1.DeviceConfig.QuietSettings.TimeOfDay
 */
export type DeviceConfig_QuietSettings_TimeOfDay = Message<"wavin.sentio.v1.DeviceConfig.QuietSettings.TimeOfDay"> & {
  /**
   * @generated from field: int32 hours = 1;
   */
  hours: number;

  /**
   * @generated from field: int32 minutes = 2;
   */
  minutes: number;
};

/**
 * Describes the message wavin.sentio.v1.DeviceConfig.QuietSettings.TimeOfDay.
 * Use `create(DeviceConfig_QuietSettings_TimeOfDaySchema)` to create a new message.
 */
export const DeviceConfig_QuietSettings_TimeOfDaySchema: GenMessage<DeviceConfig_QuietSettings_TimeOfDay> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_device_config, 0, 7, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.QuietSettings.QuietMode
 */
export enum DeviceConfig_QuietSettings_QuietMode {
  /**
   * @generated from enum value: QUIET_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUIET_MODE_OFF = 1;
   */
  OFF = 1,

  /**
   * @generated from enum value: QUIET_MODE_ON = 2;
   */
  ON = 2,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.QuietSettings.QuietMode.
 */
export const DeviceConfig_QuietSettings_QuietModeSchema: GenEnum<DeviceConfig_QuietSettings_QuietMode> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 7, 0);

/**
 * Heating and Cooling mode
 *
 * @generated from enum wavin.sentio.v1.DeviceConfig.HCMode
 */
export enum DeviceConfig_HCMode {
  /**
   * @generated from enum value: HC_MODE_UNSPECIFIED = 0;
   */
  HC_MODE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: HC_MODE_HEATING = 1;
   */
  HC_MODE_HEATING = 1,

  /**
   * @generated from enum value: HC_MODE_COOLING = 2;
   */
  HC_MODE_COOLING = 2,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.HCMode.
 */
export const DeviceConfig_HCModeSchema: GenEnum<DeviceConfig_HCMode> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 0);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.AutomaticHCMode
 */
export enum DeviceConfig_AutomaticHCMode {
  /**
   * @generated from enum value: AUTOMATIC_HC_MODE_UNSPECIFIED = 0;
   */
  AUTOMATIC_HC_MODE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUTOMATIC_HC_MODE_OFF = 1;
   */
  AUTOMATIC_HC_MODE_OFF = 1,

  /**
   * @generated from enum value: AUTOMATIC_HC_MODE_ON = 2;
   */
  AUTOMATIC_HC_MODE_ON = 2,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.AutomaticHCMode.
 */
export const DeviceConfig_AutomaticHCModeSchema: GenEnum<DeviceConfig_AutomaticHCMode> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 1);

/**
 * @generated from enum wavin.sentio.v1.DeviceConfig.StandbyMode
 */
export enum DeviceConfig_StandbyMode {
  /**
   * @generated from enum value: STANDBY_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STANDBY_MODE_OFF = 1;
   */
  OFF = 1,

  /**
   * @generated from enum value: STANDBY_MODE_ON = 2;
   */
  ON = 2,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceConfig.StandbyMode.
 */
export const DeviceConfig_StandbyModeSchema: GenEnum<DeviceConfig_StandbyMode> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0, 2);

/**
 * internal
 *
 * @generated from enum wavin.sentio.v1.PersonalizationType
 */
export enum PersonalizationType {
  /**
   * @generated from enum value: PERSONALIZATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PERSONALIZATION_TYPE_CONFIG = 1;
   */
  CONFIG = 1,

  /**
   * @generated from enum value: PERSONALIZATION_TYPE_ROOM = 2;
   */
  ROOM = 2,

  /**
   * @generated from enum value: PERSONALIZATION_TYPE_VENTILATION_CONTROL = 3;
   */
  VENTILATION_CONTROL = 3,

  /**
   * @generated from enum value: PERSONALIZATION_TYPE_VFR = 4;
   */
  VFR = 4,

  /**
   * @generated from enum value: PERSONALIZATION_TYPE_DHW = 5;
   */
  DHW = 5,
}

/**
 * Describes the enum wavin.sentio.v1.PersonalizationType.
 */
export const PersonalizationTypeSchema: GenEnum<PersonalizationType> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_device_config, 0);

